import React from "react";
import backgroundimg from "./../image/banner.png";
import { Helmet } from "react-helmet";

const Terms = () => {
  
  return (
    <div className="w-full mx-w-[1400px] h-auto bg-white flex flex-col items-center justify-center lg:mt-20 sm:mt-0">
    <Helmet>
  <title>Terms of Use - Nexify InfoSystems</title>
  <meta
    name="description"
    content="Read the Terms of Use for Nexify InfoSystems to understand the rules and conditions for using our website and services."
  />
  <meta
    name="keywords"
    content="Nexify, Terms of Use, website terms, user agreement, legal terms, conditions, Nexify InfoSystems"
  />
</Helmet>

      {/* Header Section */}
      <div
  className="w-full h-[440px] bg-cover bg-center relative flex items-center justify-center"
  style={{ backgroundImage: `url(${backgroundimg})` }}
>
  <div className="relative z-0 flex justify-center lg:justify-start items-center w-full px-4 sm:px-10 lg:px-20">
    <div
      className="opacity-0 translate-y-10 animate-slideUp bg-[#0e55a8] p-6 shadow-lg text-white inline-block text-center lg:text-left max-w-[90%] sm:max-w-[80%] md:max-w-[60%] lg:max-w-[60%] lg:ml-14 border border-white/20 rounded-lg relative"
      style={{
        animation: "slideUp 1s ease-in-out forwards",
        animationDelay: "2s",
      }}
    >
      {/* 🔵 Dot Pattern Overlay Inside Box */}
      <div className="absolute inset-0 bg-[radial-gradient(circle,_rgba(255,255,255,0.2)_1px,_transparent_1px)] bg-[size:6px_6px] opacity-50 pointer-events-none rounded-lg"></div>

      <h1 className="text-[8vw] md:text-[66px] font-semibold mb-2 break-words">
  Terms of Use
</h1>
<h2 className="text-[5vw] md:text-[40px] text-[#efefef]">
  Understand the rules for using Nexify InfoSystems services
</h2>

          </div>
        </div>
      </div>

       {/* Terms of Use Content Section */}
       <div className="bg-white flex flex-col items-left text-left p-6 w-full max-w-[1200px] mt-5 gap-6 mb-20">
        <h2 className="lg:text-[40px] text-2xl font-semibold text-[#005eb8]">
          Nexify InfoSystems Terms of Use
        </h2>

        <div>
          <h3 className="text-xl font-semibold text-gray-800 mb-2">Introduction</h3>
          <p className="text-gray-700 mb-4">
            By accessing or using the website www.nexifyinfosystems.com, you agree to comply with and be bound by the following terms and conditions ("Terms of Use"). If you do not agree to these terms, do not use this website.
          </p>
        </div>

        <div>
          <h3 className="text-xl font-semibold text-gray-800 mb-2">Use of the Website</h3>
          <p className="text-gray-700 mb-2">You may use our website only for lawful purposes and in accordance with these Terms of Use.</p>
          <p className="text-gray-700 mb-4">You agree not to engage in any conduct that may interfere with the operation of the website or harm other users.</p>
        </div>

        <div>
          <h3 className="text-xl font-semibold text-gray-800 mb-2">Intellectual Property</h3>
          <p className="text-gray-700 mb-4">
            All content on the website, including text, graphics, logos, images, and software, is owned by Nexify InfoSystems or its licensors and is protected by copyright and intellectual property laws.
          </p>
        </div>

        <div>
          <h3 className="text-xl font-semibold text-gray-800 mb-2">Limitation of Liability</h3>
          <p className="text-gray-700 mb-4">
            Nexify InfoSystems is not liable for any damages arising from your use of the website, including but not limited to direct, indirect, incidental, or consequential damages.
          </p>
        </div>

        <div>
          <h3 className="text-xl font-semibold text-gray-800 mb-2">Termination</h3>
          <p className="text-gray-700 mb-4">
            We may terminate or suspend access to our website immediately, without prior notice, for any reason, including if you violate these Terms of Use.
          </p>
        </div>

        <div>
          <h3 className="text-xl font-semibold text-gray-800 mb-2">Changes to These Terms</h3>
          <p className="text-gray-700">
            We may update these Terms of Use at any time. Any changes will be posted on this page. Your continued use of the website after such changes constitutes your acceptance of the updated terms.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Terms;

    